import { AbstractControl } from '@angular/forms';

export class ConfirmPasswordValidator {
  /**
   * Check matching password with confirm password
   * @param control AbstractControl
   */
  static MatchPassword(control: AbstractControl) {
    const password = control.get('NewPassword').value;

    const confirmPassword = control.get('ConfirmPassword').value;

    if (password !== confirmPassword) {
      control.get('ConfirmPassword').setErrors({ ConfirmPassword: true });
    } else {
      return null;
    }
  }
}
